import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { MdEmail } from "react-icons/md";
import { RiLockPasswordFill } from "react-icons/ri";
import { useState } from "react";
import useAuth from "../../Hooks/useAuth";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const Login = () => {
  const { isLogin, setIsLogin,showDummyImage } = useAuth();
  const navigate = useNavigate();
  const [userCredential, setUserCredential] = useState({
    email: "",
    password: "",
    checked: "off",
  });
  const setCredentials = (e) => {
    e.preventDefault();
    let value = e.target.value;
      setUserCredential({
        ...userCredential,
        [e.target.name]: value,
      });
  };
  const setCheckBox = (e) => {
    let isChecked = e.target.checked;
    let value = e.target.value;
    setUserCredential({
      ...userCredential,
      [e.target.name]: isChecked ? value : "Off",
    });
  };

  const handleUsers = (e) => {
    e.preventDefault();
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(userCredential?.email)) {
      toast.error('Invalid Email', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        });
    }else if (userCredential.password.length < 6) {
      toast.error('Please set 6 character atleast', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        });
    } else {
      localStorage.setItem("credentials", JSON.stringify(userCredential));
      navigate("/");
      setIsLogin(!isLogin);
    }
  };

  return (
    <section className="login">
      <div>
        <ToastContainer />
      </div>
      <div className="container">
        <div className="login-wrapper">
          <div className="login-left">
            <div className="login-left-img">
              <img src={require("../../assets/images/login/login.png")} alt={'login'} onError={({ currentTarget },imageSize = "520X570") => showDummyImage({ currentTarget }, imageSize)}/>
            </div>
          </div>
          <div className="login-right">
            <div className="login-content">
              <h2>Get’s Started.</h2>
              <p>
                New Account Get Register?
                <Link to={"/signup"} className="register">
                  Register Now
                </Link>
              </p>
            </div>
            <form onSubmit={handleUsers} className="login-form">
              <div className="login-input">
                <input
                  onChange={setCredentials}
                  type="email"
                  placeholder="Email"
                  name="email"
                />
                <div className="login-input-icon-container">
                  {" "}
                  <MdEmail className="login-input-icon" />
                </div>
              </div>
              <div className="login-input">
                <input
                  onChange={setCredentials}
                  type="password"
                  placeholder="Password"
                  name="password"
                />
                <div className="login-input-icon-container">
                  <RiLockPasswordFill className="login-input-icon" />
                </div>
              </div>
              <div className="login-checkbox">
                <div className="checkbox">
                  <input
                    onChange={setCheckBox}
                    type="checkbox"
                    name="checked"
                  />
                  <label>Remember Me</label>
                </div>
                <Link to={""} className="forgot-pass">
                  Forgot password?
                </Link>
              </div>
              <input
                type="submit"
                value="LogIn Your Account"
                className="login-submit"
              />
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Login;
